import React from "react";
import scoreReportImage from "assets/online-web.png";
import resultBubbleSheetImage from "assets/bubblesheet-web.png";
import "./index.scss";
import classNames from "classnames";

interface IProps {
  theme:"light"|"dark";
  isScoreReport: boolean;
  imageWidth?: number;
  imageHeight?: number;
  containerWidth: number;
  containerHeight: number;
}
export const PracticeModalIcon = ({
  theme,
  isScoreReport,
  imageHeight,
  imageWidth,
  containerHeight,
  containerWidth,
}: IProps) => {
  return (
    <div className={classNames("score-report-icon-wrapper",`${theme}`)} style={{height:`${containerHeight}px`,width:`${containerWidth}px`}}>
      <img
        src={isScoreReport ? scoreReportImage : resultBubbleSheetImage}
        alt=""
        width={imageWidth}
        height={imageHeight}
      />
    </div>
  );
};
